<template>
    <SfSection v-if="block && block.quote">
        <template v-slot:default>
            <sf-content-container>
                <sf-quote :quote="block.quote" />
            </sf-content-container>
        </template>
    </SfSection>
</template>

<script>
import contentBlockMixin from '~/mixins/content-block';
import SfSection from '~/patterns/organisms/section/section';
import SfContentContainer from '~/patterns/organisms/content-container/content-container';
import SfQuote from '~/patterns/atoms/quote/quote.vue';

export default {
    components: {
        SfSection,
        SfContentContainer,
        SfQuote
    },

    mixins: [
        contentBlockMixin
    ],

    props: {
        link: {
            type: Object,
            default: null
        }
    }
};
</script>
